<template>
	<fade-transition :duration="200" origin="center top" mode="out-in">
		<div
			:class="contentClass"
			:style="{ minHeight: contentHeight }"
			class="router-view"
		>
			<router-view></router-view>
		</div>
	</fade-transition>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
	name: "app-content",
	props: {
		contentHeight: {
			type: String,
			default: `100vh`,
		},
	},
	components: {
		FadeTransition,
	},
	computed: {
		contentClass() {
			return this.$route.meta.flexContainer
				? "d-flex align-items-center justify-content-center"
				: "";
		},
	},
};
</script>
